<footer id="footer">

  <div class="footer-newsletter">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <h4>Rejoignez notre newsletter</h4>
          <p>Consultez régulièrement notre site web ou inscrivez-vous à notre newsletter.</p>
          <form action="" method="post">
            <input type="email" name="email"><input type="submit" value="S'abonner">
          </form>
        </div>
      </div>
    </div>
  </div>

    <div class="footer-top">
      <div class="container">
        <div class="row">

          <div class="col-lg-3 col-md-6 footer-contact">
            <h3>STAR Engineering</h3>
            <p>
            75,Avenue Kheireddine Pacha, <br>Immeuble Pacha Centre,<br> Bloc B 2ème étage, bureau n°5<br>
					1073 Montplaisir<br>
					Tunis, Tunisie <br><br>
          
              <strong>Phone:</strong> (+216)71951508<br>
              <strong>Email:</strong> star@star-consult.com<br>
            </p>
          </div>

          <div class="col-lg-3 col-md-6 footer-links">
            <h4>Liens utiles</h4>
            <ul>
              <li><i class="bx bx-chevron-right"></i> <a href="#">Accueil</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="#">À Propos de nous</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="#">Services</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="#">Actualités</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="#">Evennements</a></li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-6 footer-links">
            <h4>Industrie</h4>
            <ul>
              <li><i class="bx bx-chevron-right"></i> <a href="#">Plasturgie</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="#">Agroalimentaire</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="#">Dispositifs médicaux</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="#">Cosmétique</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="#">Pharmacie</a></li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-6 footer-links">
            <h4>Nos réseaux sociaux</h4>
            <p>SUIVEZ-NOUS :</p>
            <div class="social-links mt-3">
              <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
              <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
              <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
              <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
              <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="container footer-bottom clearfix">
      <div class="copyright">
        &copy; Copyright <strong><span>STAR Engineering</span></strong>. All Rights Reserved
      </div>
      <div class="credits">
        <!-- All the links in the footer should remain intact. -->
        <!-- You can delete the links only if you purchased the pro version. -->
        <!-- Licensing information: https://bootstrapmade.com/license/ -->
        <!-- Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/arsha-free-bootstrap-html-template-corporate/ -->
        Designed by <a href="#">Star Engineering</a>
      </div>
    </div>
  </footer><!-- End Footer -->

  <!--<div id="preloader"></div>-->
  <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>

